import { Box, Button, Modal, Typography } from '@servicepipe/ui-components';
import React from 'react';

export const ModalDeleteAccessGroup = ({ groupName, loading = false, onClose, onConfirm }) => (
  <Modal
    enableMaximize={false}
    size="s"
    title="Delete group"
    toggle={onClose}
    footer={
      <Box display="flex" justify="flex-end" gap="8px" width="100%" padding="0 8px">
        <Button
          variant="outline"
          color="neutral"
          type="button"
          isDisabled={loading}
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          variant="solid"
          color="accent"
          isDisabled={loading}
          isLoading={loading}
          onClick={onConfirm}
        >
          Delete
        </Button>
      </Box>
    }
  >
    <Typography variant="bodyMR">
      Are you sure you want to delete <strong>{groupName}</strong>? All users in this group will
      lose access to the assigned resources immediately.
    </Typography>
  </Modal>
);
